import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class BrandValuesComponent extends Component {
  #io = null;

  connectedCallback() {
    super.connectedCallback();
    if (prefersReducedMotion()) {
      this.classList.add('is-visible');
      this.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-visible'));
      return;
    }
    this.#io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          if (e.target === this) {
            this.classList.add('is-visible');
          } else {
            e.target.classList.add('is-visible');
            this.#io?.unobserve(e.target);
          }
        }
      }
    }, { rootMargin: '0px 0px -10% 0px' });
    this.#io.observe(this);
    this.querySelectorAll('.reveal').forEach((el) => this.#io.observe(el));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#io?.disconnect();
  }
}

if (!customElements.get('brand-values-component')) {
  customElements.define('brand-values-component', BrandValuesComponent);
}
